import React, { createContext, useContext } from "react";

const PageListContext = createContext("");

const PageListProvider = ({ children, allSitePage, allCustomRedirect }) => {
    const pageList = {};
    for (const page of allSitePage?.nodes) {
        pageList[page?.path] = true;
    }

    const redirectList = {};
    for (const redirect of allCustomRedirect?.nodes) {
        redirectList[redirect?.fromPath] = true;
    }

    return <PageListContext.Provider value={{ pageList, redirectList }}>{children}</PageListContext.Provider>;
};

const usePageList = () => {
    const context = useContext(PageListContext);

    if (!context) {
        throw new Error("usePageList must be used within an PageListProvider");
    }

    return context;
};

export { PageListProvider, usePageList };
